import { institutionalApi } from "./index";
import {
  RouterSupportedDOCountry,
  // RouterTransferMethods,
} from "interfaces/enums";

import {
  IRouterCreateBankAccUs,
  IRequestRouterGetBankAcc,
  IRouterCreateBankAccMX,
  IRouterCreateBankAcc,
  DestinationAccount,
} from "interfaces/router";
import { transformErrorResponse } from "utils";

export const ccyConversionOrdersrouter = institutionalApi.injectEndpoints({
  endpoints: (builder) => ({
    getBankAccountsRouter: builder.query<
      Array<IRouterCreateBankAcc>,
      IRequestRouterGetBankAcc
    >({
      query: (params) => ({
        url: "/router/bank_account",
        params,
        method: "GET",
      }),
      providesTags: [{ type: "RouterAccounts" }],
      transformErrorResponse,
    }),

    getSPIDBeneficiaryOptions: builder.query<
      {
        entity_types: Record<string, string>;
        business_category_options: Array<string>;
      },
      { language: "en" | "es" | "zh" }
    >({
      query: (params) => ({
        url: `/router/spid/beneficiary_options`,
        method: "GET",
        params,
      }),
      transformErrorResponse,
    }),

    getBankNames: builder.query<
      Array<string>,
      { country: RouterSupportedDOCountry }
    >({
      query: (params) => ({
        url: `/router/banks/${params.country}`,
        method: "GET",
      }),
      providesTags: [{ type: "RouterAccountsMX" }],
      transformErrorResponse,
    }),

    deleteBankAccount: builder.mutation<
      string,
      { destination_account_id: string; sub_account_id?: string }
    >({
      query: (body) => ({
        url: "/router/bank_account",
        method: "DELETE",
        params: body,
      }),
      transformErrorResponse,
      invalidatesTags: [
        { type: "RouterMXAccounts" },
        { type: "RouterAccounts" },
        { type: "RouterUsAccounts" },
      ],
    }),

    createBankAccountMXRouter: builder.mutation<
      DestinationAccount,
      IRouterCreateBankAccMX
    >({
      query: (body) => ({
        url: "/router/bank_account",
        method: "POST",
        body,
      }),
      transformErrorResponse,
      invalidatesTags: [
        { type: "RouterMXAccounts" },
        { type: "RouterAccounts" },
        { type: "RouterUsAccounts" },
      ],
    }),

    createBankAccountRouter: builder.mutation<
      DestinationAccount,
      IRouterCreateBankAccUs
    >({
      query: ({ id, ...body }) => ({
        url: `/router/bank_account${id ? `/${id}` : ""}`,
        method: id ? "PATCH" : "POST",
        body,
      }),
      transformErrorResponse,
      invalidatesTags: [
        { type: "RouterMXAccounts" },
        { type: "RouterAccounts" },
        { type: "RouterUsAccounts" },
      ],
    }),
  }),
});

export const {
  useGetBankNamesQuery,
  useDeleteBankAccountMutation,
  useGetBankAccountsRouterQuery,
  useCreateBankAccountRouterMutation,
  useGetSPIDBeneficiaryOptionsQuery,
  useCreateBankAccountMXRouterMutation,
} = ccyConversionOrdersrouter;
